import { render, staticRenderFns } from "./IconComponent.vue?vue&type=template&id=24ef4a02&scoped=true"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"
import style0 from "./IconComponent.vue?vue&type=style&index=0&id=24ef4a02&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef4a02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ef4a02')) {
      api.createRecord('24ef4a02', component.options)
    } else {
      api.reload('24ef4a02', component.options)
    }
    module.hot.accept("./IconComponent.vue?vue&type=template&id=24ef4a02&scoped=true", function () {
      api.rerender('24ef4a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/IconComponent.vue"
export default component.exports